export default __webpack_public_path__ + "static/media/flows.966fae7a.svg";